import { Button, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { kirimWA } from "../models/kirimWa";

function TambahanPart() {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography
        variant="h6"
        color="primary"
        sx={{ fontWeight: "bold", textAlign: "center", p: 2, mt: 4 }}
      >
        Lebih dekat dengan kunjungi dan follow sosial media Gedepari Trans
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          startIcon={<FacebookIcon />}
          fullWidth
          color="primary"
          variant="outlined"
          //   component="link"
          href="https://www.facebook.com/pages/category/Travel-Company/Gede-Pari-trans-wisata-108420551008157/"
          target="_blank"
          sx={{ m: 1 }}
        >
          Facebook
        </Button>
        <Button
          startIcon={<InstagramIcon />}
          fullWidth
          color="warning"
          variant="outlined"
          //   component="link"
          href="https://www.instagram.com/gedepari_transwisata/"
          target="_blank"
          sx={{ m: 1 }}
        >
          Instagram
        </Button>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          startIcon={<LocationOnIcon />}
          fullWidth
          color="error"
          variant="outlined"
          href="https://goo.gl/maps/LXGc5mhasFFDro2NA"
          target="_blank"
          sx={{ m: 1 }}
        >
          Maps
        </Button>
        <Button
          startIcon={<WhatsAppIcon />}
          fullWidth
          color="success"
          variant="outlined"
          //   component="link"
          onClick={() => kirimWA("Mohon info Gedepari Trans")}
          sx={{ m: 1 }}
        >
          Whatsapp
        </Button>
      </Box>
    </Paper>
  );
}

export default TambahanPart;
